import { type ReactNode } from 'react'

import { Modal, TransparentIconButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import sparkleSVG from './assets/sparkle.svg'
import messages from './messages'
import {
  GlobalCommandModalBodyContentStyled,
  GlobalCommandModalBodyStyled,
  GlobalCommandModalCloseAreaStyled,
  GlobalCommandModalFooterContentStyled,
  GlobalCommandModalFooterStyled,
  GlobalCommandModalHeaderIconStyled,
  GlobalCommandModalHeaderStyled,
  GlobalCommandModalShellStyled,
  GlobalCommandModalTitleStyled,
} from './styles/GlobalCommandModalLayoutStyled'

const dismissPopovers = () => document.body.click()

interface IGlobalCommandModalProps {
  isOpen: boolean
  onClose: () => void
  onEntered?: () => void
  children: ReactNode
  isConversation?: boolean
  title?: ReactNode
  footer?: ReactNode
}

export const GlobalCommandModal = ({
  isOpen,
  onClose,
  onEntered,
  children,
  isConversation = false,
  title,
  footer,
}: IGlobalCommandModalProps) => {
  const intl = useProcurifyIntl()

  return (
    <Modal
      aria-label={intl.formatMessage(messages.modalAriaLabel)}
      maxWidth={false}
      open={isOpen}
      onClose={onClose}
      keepMounted
      TransitionProps={{ onEnter: dismissPopovers, onEntered }}
    >
      <Modal.Card cycleFocus>
        <GlobalCommandModalShellStyled $isConversation={isConversation}>
          {isConversation && (
            <GlobalCommandModalHeaderStyled>
              <GlobalCommandModalHeaderIconStyled src={sparkleSVG} />
              {title && (
                <GlobalCommandModalTitleStyled>
                  {title}
                </GlobalCommandModalTitleStyled>
              )}
            </GlobalCommandModalHeaderStyled>
          )}

          <GlobalCommandModalCloseAreaStyled>
            <TransparentIconButton
              aria-label={intl.formatMessage(messages.closeButtonAriaLabel)}
              icon='times'
              analyticsId='global-search-close-button'
              onClick={onClose}
            />
          </GlobalCommandModalCloseAreaStyled>

          <GlobalCommandModalBodyStyled $isConversation={isConversation}>
            <GlobalCommandModalBodyContentStyled
              $isConversation={isConversation}
            >
              {children}
            </GlobalCommandModalBodyContentStyled>
          </GlobalCommandModalBodyStyled>

          {isConversation && footer && (
            <GlobalCommandModalFooterStyled>
              <GlobalCommandModalFooterContentStyled>
                {footer}
              </GlobalCommandModalFooterContentStyled>
            </GlobalCommandModalFooterStyled>
          )}
        </GlobalCommandModalShellStyled>
      </Modal.Card>
    </Modal>
  )
}
